import { Achievement, Badge } from '../types';

export const achievements: Achievement[] = [
  // --- Crime Game Achievements ---
  {
    id: 'novice-detective',
    name: 'Novice Detective',
    description: 'You solved your first case!',
    icon: '/icons/achievements/detective.svg',
    condition: {
      type: 'crimeCasesSolved',
      value: 1,
      description: 'Solve 1 crime case'
    },
    rarity: 'common',
    points: 25
  },
  {
    id: 'case-cracker',
    name: 'Case Cracker',
    description: 'You solved 5 cases!',
    icon: '/icons/achievements/detective-expert.svg',
    condition: {
      type: 'crimeCasesSolved',
      value: 5,
      description: 'Solve 5 crime cases'
    },
    rarity: 'rare',
    points: 75
  },
  {
    id: 'master-detective',
    name: 'Master Detective',
    description: 'You solved 10 cases!',
    icon: '/icons/achievements/detective-master.svg',
    condition: {
      type: 'crimeCasesSolved',
      value: 10,
      description: 'Solve 10 crime cases'
    },
    rarity: 'epic',
    points: 200
  },
  {
    id: 'perfect-investigation',
    name: 'Perfect Investigation',
    description: 'You solved a case with 0 hints!',
    icon: '/icons/achievements/perfect-investigation.svg',
    condition: {
      type: 'crimeHintsUsed',
      value: 0,
      description: 'Solve a case with 0 hints'
    },
    rarity: 'rare',
    points: 100
  },
  {
    id: 'speed-solver',
    name: 'Speed Solver',
    description: 'You solved a case in under 2 minutes!',
    icon: '/icons/achievements/stopwatch.svg',
    condition: {
      type: 'crimeTime',
      value: 120,
      description: 'Solve a case in under 120 seconds'
    },
    rarity: 'epic',
    points: 150
  },
  {
    id: 'crime-spree',
    name: 'Crime Game Streak',
    description: 'You solved cases on 3 consecutive days!',
    icon: '/icons/achievements/streak.svg',
    condition: {
      type: 'crimeStreak',
      value: 3,
      description: 'Solve cases for 3 consecutive days'
    },
    rarity: 'rare',
    points: 100
  },
  // --- Daily Training Achievements ---
  {
    id: 'training-rookie',
    name: 'Training Rookie',
    description: 'You completed your first daily training session!',
    icon: '/icons/achievements/training.svg',
    condition: {
      type: 'dailyTrainingCompleted',
      value: 1,
      description: 'Complete 1 daily training session'
    },
    rarity: 'common',
    points: 20
  },
  {
    id: 'training-dedicated',
    name: 'Training Dedicated',
    description: 'You completed 5 daily training sessions!',
    icon: '/icons/achievements/training-bronze.svg',
    condition: {
      type: 'dailyTrainingCompleted',
      value: 5,
      description: 'Complete 5 daily training sessions'
    },
    rarity: 'rare',
    points: 60
  },
  {
    id: 'training-master',
    name: 'Training Master',
    description: 'You completed 10 daily training sessions!',
    icon: '/icons/achievements/training-gold.svg',
    condition: {
      type: 'dailyTrainingCompleted',
      value: 10,
      description: 'Complete 10 daily training sessions'
    },
    rarity: 'epic',
    points: 150
  },
  // --- Existing Achievements ---
  {
    id: 'first-steps',
    name: 'First Steps',
    description: 'You learned your first word!',
    icon: '/icons/achievements/first-steps.svg',
    condition: {
      type: 'wordsLearned',
      value: 1,
      description: 'Learn your first word'
    },
    rarity: 'common',
    points: 10
  },
  {
    id: 'word-collector',
    name: 'Word Collector',
    description: 'You learned 5 words!',
    icon: '/icons/achievements/word-smith.svg',
    condition: {
      type: 'wordsLearned',
      value: 5,
      description: 'Learn 5 words'
    },
    rarity: 'common',
    points: 25
  },
  {
    id: 'word-smith',
    name: 'Word Smith',
    description: 'You learned 10 words!',
    icon: '/icons/achievements/word-smith.svg',
    condition: {
      type: 'wordsLearned',
      value: 10,
      description: 'Learn 10 words'
    },
    rarity: 'common',
    points: 50
  },
  {
    id: 'vocabulary-builder',
    name: 'Vocabulary Builder',
    description: 'You learned 25 words!',
    icon: '/icons/achievements/polyglot.svg',
    condition: {
      type: 'wordsLearned',
      value: 25,
      description: 'Learn 25 words'
    },
    rarity: 'rare',
    points: 100
  },
  {
    id: 'polyglot',
    name: 'Polyglot',
    description: 'You learned 50 words!',
    icon: '/icons/achievements/polyglot.svg',
    condition: {
      type: 'wordsLearned',
      value: 50,
      description: 'Learn 50 words'
    },
    rarity: 'epic',
    points: 200
  },
  {
    id: 'language-master',
    name: 'Language Master',
    description: 'You learned 100 words!',
    icon: '/icons/achievements/polyglot.svg',
    condition: {
      type: 'wordsLearned',
      value: 100,
      description: 'Learn 100 words'
    },
    rarity: 'legendary',
    points: 500
  },
  {
    id: 'streak-starter',
    name: 'Streak Starter',
    description: 'You practiced for 3 days in a row!',
    icon: '/icons/achievements/first-steps.svg',
    condition: {
      type: 'streak',
      value: 3,
      description: 'Practice for 3 consecutive days'
    },
    rarity: 'common',
    points: 30
  },
  {
    id: 'dedicated-learner',
    name: 'Dedicated Learner',
    description: 'You practiced for 7 days in a row!',
    icon: '/icons/achievements/word-smith.svg',
    condition: {
      type: 'streak',
      value: 7,
      description: 'Practice for 7 consecutive days'
    },
    rarity: 'rare',
    points: 75
  },
  {
    id: 'consistency-champion',
    name: 'Consistency Champion',
    description: 'You practiced for 30 days in a row!',
    icon: '/icons/achievements/polyglot.svg',
    condition: {
      type: 'streak',
      value: 30,
      description: 'Practice for 30 consecutive days'
    },
    rarity: 'epic',
    points: 300
  },
  {
    id: 'theme-explorer',
    name: 'Theme Explorer',
    description: 'You completed your first theme!',
    icon: '/icons/achievements/first-steps.svg',
    condition: {
      type: 'themesCompleted',
      value: 1,
      description: 'Complete your first theme'
    },
    rarity: 'common',
    points: 50
  },
  {
    id: 'theme-master',
    name: 'Theme Master',
    description: 'You completed 5 themes!',
    icon: '/icons/achievements/word-smith.svg',
    condition: {
      type: 'themesCompleted',
      value: 5,
      description: 'Complete 5 themes'
    },
    rarity: 'rare',
    points: 150
  },
  {
    id: 'perfect-score',
    name: 'Perfect Score',
    description: 'You got a perfect score in an activity!',
    icon: '/icons/achievements/polyglot.svg',
    condition: {
      type: 'perfectScore',
      value: 1,
      description: 'Get a perfect score in any activity'
    },
    rarity: 'rare',
    points: 100
  },
  {
    id: 'activity-champion',
    name: 'Activity Champion',
    description: 'You completed 50 activities!',
    icon: '/icons/achievements/polyglot.svg',
    condition: {
      type: 'activitiesCompleted',
      value: 50,
      description: 'Complete 50 activities'
    },
    rarity: 'epic',
    points: 250
  }
];

export const badges: Badge[] = [
  {
    id: 'early-bird',
    name: 'Early Bird',
    description: 'You practiced 5 days in a row before 9 AM.',
    icon: '/icons/badges/early-bird.svg',
    condition: {
      type: 'dailyStreak',
      value: 5,
      description: 'Practice for 5 consecutive days before 9 AM'
    },
    rarity: 'rare',
    points: 75
  },
  {
    id: 'night-owl',
    name: 'Night Owl',
    description: 'You practiced after 10 PM.',
    icon: '/icons/badges/night-owl.svg',
    condition: {
      type: 'nightPractice',
      value: 1,
      description: 'Practice after 10 PM'
    },
    rarity: 'common',
    points: 25
  },
  {
    id: 'weekend-warrior',
    name: 'Weekend Warrior',
    description: 'You practiced on 4 consecutive weekends.',
    icon: '/icons/badges/early-bird.svg',
    condition: {
      type: 'weekendPractice',
      value: 4,
      description: 'Practice on 4 consecutive weekends'
    },
    rarity: 'epic',
    points: 200
  },
  {
    id: 'perfect-week',
    name: 'Perfect Week',
    description: 'You practiced every day for a week.',
    icon: '/icons/badges/night-owl.svg',
    condition: {
      type: 'perfectWeek',
      value: 7,
      description: 'Practice every day for a week'
    },
    rarity: 'rare',
    points: 150
  },
  {
    id: 'social-butterfly',
    name: 'Social Butterfly',
    description: 'You shared 10 achievements on social media.',
    icon: '/icons/badges/early-bird.svg',
    condition: {
      type: 'socialSharing',
      value: 10,
      description: 'Share 10 achievements on social media'
    },
    rarity: 'epic',
    points: 300
  },
  {
    id: 'monthly-goal-crusher',
    name: 'Monthly Goal Crusher',
    description: 'You exceeded your monthly learning goal.',
    icon: '/icons/badges/night-owl.svg',
    condition: {
      type: 'monthlyGoal',
      value: 1,
      description: 'Exceed your monthly learning goal'
    },
    rarity: 'legendary',
    points: 500
  }
];
